import setCurrentPage from "src/Utils/setCurrentPage";

const cards: CardDemoProps[] = [
  {
    image: "ENG/edge.jpg",
    imageStyle: { width: "100%" },
    title: "MANAGE YOUR\n EDGE APPLICATIONS",
    titleStyle: { marginTop: "16px" },
    text: "Our versatile platform offering end-to-end\n edge computing management capabilities.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("ENG_101"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "ENG/eng1.jpg",
    imageStyle: { width: "100%" },
    title: "Infosys Smart \nNetwork Assurance ",
    titleStyle: { marginTop: "16px" },
    text: "AI and Gen AI enabled Network Assurance solution providing accelerated journey towards autonomous network operations.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("ENG_201"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    image: "ENG/eng2.jpg",
    imageStyle: { width: "100%" },
    title: "Infosys Network\nLifecycle Manager",
    titleStyle: { marginTop: "16px" },
    text: "The maestro of multi-domain network; \norchestrating your network's end-to-end \nlifecycle with efficiency.",
    choose: {
      label: "Select",
      onClick: () => setCurrentPage("ENG_301"),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
];

const data = {
  bgImage: "ENG/bg.png",
  subtitle: "Select a demo to experience Intelligent Networks of the future products",
  cards: cards,
  showHomeButton: true,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("INTRO_0"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
};

export default data;
